<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Can't Sign In?</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="resetPassword">
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <v-flex v-if="!sentResetLink">
              <div>We'll send a recovery link to</div>
              <v-text-field
                v-if="!sentResetLink"
                name="email"
                label="Enter email"
                id="email"
                type="email"
                v-model="email"
                :rules="emailRules"
                prepend-icon="mail"
                required>
              </v-text-field>
            </v-flex>
            <v-flex v-if="sentResetLink">
              <v-layout justify-center>
              <p>We sent a recovery link to your email address: {{ email }}</p>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="!sentResetLink"
              class="text-xs-center" mt-5>
              <v-btn
                color="primary"
                type="submit"
                :disabled="loading">
                Send Recovery Link
              </v-btn>
              <v-btn
                outline
                color="primary"
                @click.stop="toRoute('signin')"
                target="_blank">
                Return to Sign In
              </v-btn>
            </v-flex>
            <v-flex
              v-if="sentResetLink"
              class="text-xs-center" mt-5>
              <v-btn
                color="primary"
                @click.stop="toRoute('signin')"
                target="_blank">
                Return to Sign In
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      alert: false,
      sentResetLink: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => v.substring(v.indexOf('@')) === '@amirbaradaran.com' ||
             'Features for in-house user'
      ]
    }
  },
  computed: {
    error () {
      return this.$store.state.error
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    resetPassword () {
      if (this.validateForm()) {
        this.$store.dispatch('resetPassword', { email: this.email })
      }
    },
    toRoute (rname, rparams = {}, query = {}) {
      this.$store.commit('setError', null)
      this.$router.push({name: rname, params: rparams, query: query})
    },
    validateForm () {
      return this.email.substring(this.email.indexOf('@')) === '@amirbaradaran.com' &&
        this.alert === false
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    },
    loading (value) {
      if (value === false && this.validateForm()) {
        this.sentResetLink = true
      }
    },
    email (value) {
      this.alert = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Forgot.vue